import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BankIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M11.2964 3.12811C11.75 2.9573 12.25 2.9573 12.7036 3.12811L20.028 5.88649C20.6147 6.10746 21 6.66895 21 7.29249V8.45092C21 9.2765 20.3324 9.95305 19.5 9.95305H19V15.9872H19.5C20.3324 15.9872 21 16.6637 21 17.4893V19.4979C21 20.3235 20.3324 21 19.5 21H4.5C3.66756 21 3 20.3235 3 19.4979V17.4893C3 16.6637 3.66756 15.9872 4.5 15.9872H5V9.95305H4.5C3.66756 9.95305 3 9.2765 3 8.45092V7.29249C3 6.66895 3.38527 6.10746 3.972 5.88649L11.2964 3.12811ZM7 9.95305V15.9872H9V9.95305H7ZM5 7.95305V7.63648L12 5.00027L19 7.63648V7.95305H5ZM11 9.95305V15.9872H13V9.95305H11ZM15 9.95305V15.9872H17V9.95305H15ZM5 17.9872V19H19V17.9872H5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

BankIcon.propTypes = {
  ...sizePropsTypes,
};

export default BankIcon;
